import type { Ref } from 'vue';
import { computed } from 'vue';
import type { PricingTableRow, PricingTableSection } from '../types/pricing-table';

export function usePricingTableRows(section: Ref<PricingTableSection>) {
  const rows = computed<PricingTableRow[]>(() =>
    (section.value.rows || []).map(row => ({
      ...row,
      values: section.value.columns.flatMap(({ id }) => {
        const val = (row.values || []).find(({ columnId }) => columnId === id);
        return val ? [val] : [{ columnId: id, value: '' }];
      }),
    }))
  );

  return {
    rows,
  };
}
